import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ComponentStyles } from "../../models/app";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import LinearProgress from "@mui/material/LinearProgress";
import { IOPSSummary } from "../../models/game";
import CountUp from "react-countup";

interface Props {
  summary: IOPSSummary;
  gameIsStarted?: boolean;
  gameIsRunning?: boolean;
}

const styles: ComponentStyles = {
  iops: {
    fontSize: "1.3rem",
    width: "100%",
    textAlign: "right",
    marginLeft: "2px",
  },
  iopsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
  },
};

const getCompactNumberStr = (iops: number): string => {
  if (iops < 1000) return iops.toFixed(0).toString();
  if (iops < 1000000) return `${(iops / 1000).toFixed(1)}K`;
  if (iops < 1000000000) return `${(iops / 1000000).toFixed(1)}M`;
  if (iops < 1000000000000) return `${(iops / 1000000000).toFixed(2)}B`;
  return `${(iops / 1000000000000000).toFixed(2)}T`;
};

const getProgressBarColor = (percentageSuccess: number): string => {
  if (percentageSuccess < 50) return "red";
  if (percentageSuccess < 70) return "orange";
  if (percentageSuccess < 90) return "yellow";
  return "green";
};

export const IopsSummary: React.FC<Props> = ({ summary, gameIsStarted, gameIsRunning }) => {
  const classes = styles;
  const animDuration = gameIsRunning ? 2 : 0;

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "auto",
        padding: "0px 10px",
        height: "100%",
        minWidth: "70px"
      }}
    >
      <Box style={classes.iopsContainer}>
        <ArrowCircleDownIcon style={{ color: "blue" }} />
        <Typography variant="h2" style={classes.iops}>
          <CountUp
            end={summary.inputTotal}
            duration={animDuration}
            formattingFn={getCompactNumberStr}
            preserveValue
          />
        </Typography>
      </Box>

      {!gameIsStarted && <hr style={{ width: "100%" }} />}
      {gameIsStarted && (
        <LinearProgress
          variant="determinate"
          sx={{
            margin: "5px 0px",
            width: "100%",
            "& .MuiLinearProgress-bar": {
              backgroundColor: getProgressBarColor(summary.percentSuccess),
            },
            backgroundColor: "#CECECE",
          }}
          value={summary.percentSuccess < 10 ? 10 : summary.percentSuccess}
        />
      )}
      <Box style={classes.iopsContainer}>
        <ArrowCircleDownIcon style={{ color: "green" }} />
        <Typography variant="h2" style={classes.iops}>
          <CountUp
            end={summary.outputTotal}
            duration={animDuration}
            formattingFn={getCompactNumberStr}
            preserveValue
          />
        </Typography>
      </Box>
    </Box>
  );
};
